// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.marquee[data-v-3cca45e6] {\n    white-space: nowrap;\n    overflow: hidden;\n    box-sizing: border-box;\n    width: 100%;\n}\n.marquee span[data-v-3cca45e6] {\n    display: inline-block;\n    padding-left: 100%;\n    animation: marquee 50s linear infinite;\n    animation-delay: 0.5s;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
